// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.layered {
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.layered-no-overlap {
  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.no-gutter > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.gray {
  color: #292727;
}

.heading, .day-heading, .jump-popup-wrapper .open-date-picker .react-datepicker .react-datepicker__current-month, .current-day-heading {
  font-weight: 200;
  text-transform: uppercase;
  color: #999;
}

.day-heading, .jump-popup-wrapper .open-date-picker .react-datepicker .react-datepicker__current-month, .current-day-heading {
  color: #555;
  font-size: 1.2rem;
  padding-bottom: 0.5rem;
}

.current-day-heading {
  font-weight: bold;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  clip-path: inset(50%);
  border: 0;
}

.jump-popup-wrapper {
  display: inline-block;
  position: relative;
}
@media (max-width: 768px) {
  .jump-popup-wrapper {
    display: none;
  }
}
.jump-popup-wrapper .open-jump-popup {
  color: #c0c0c0;
  margin-left: 0.5rem;
  cursor: pointer;
  font-size: 1.5rem;
}
.jump-popup-wrapper .jump-popup {
  position: absolute;
  z-index: 6000;
  transform: translateX(-50%);
  margin-left: 1.6rem;
  margin-top: 0.1rem;
  background: white;
  padding: 1rem 1rem 0;
  display: flex;
  flex-flow: column;
  align-items: stretch;
  box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);
  color: #696969;
}
.jump-popup-wrapper .jump-popup__heading {
  margin: 0 0 1rem;
  font-size: 2rem;
  width: 100%;
}
.jump-popup-wrapper .jump-popup__body {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  align-content: center;
  margin: 0 0 0rem;
  width: 18rem;
}
.jump-popup-wrapper .jump-popup__body .open-date-picker {
  margin: auto;
}
.jump-popup-wrapper .jump-popup__buttons {
  text-align: right;
}
.jump-popup-wrapper .jump-popup__buttons .btn-default {
  min-width: 8rem;
}
.jump-popup-wrapper .jump-popup label,
.jump-popup-wrapper .jump-popup .label {
  font-weight: 100;
  -webkit-font-smoothing: subpixel-antialiased;
}
.jump-popup-wrapper .open-date-picker .react-datepicker {
  border: 0;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__current-month {
  word-spacing: 4rem;
  margin-bottom: 1rem;
  font-weight: normal;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__current-month:first-line {
  font-size: 1.8rem !important;
  font-weight: normal;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__navigation--previous {
  color: #292727;
  left: 1rem;
  top: 3rem;
  display: inline-block;
  font: normal normal normal 1.4rem/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  overflow: visible;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__navigation--previous:after {
  content: "\\f053";
  font-size: 1.2rem;
  font-weight: normal;
  color: #c0c0c0;
  text-indent: 0;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__navigation--next {
  color: #292727;
  display: inline-block;
  font: normal normal normal 1.4rem/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  right: 1.2rem;
  top: 3rem;
  overflow: visible;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__navigation--next:after {
  content: "\\f054";
  font-size: 1.2rem;
  font-weight: normal;
  color: #c0c0c0;
  text-indent: 0;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__month-container {
  width: 100%;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__month-container .react-datepicker__header {
  text-align: center;
  margin: auto;
  font-family: Raleway !important;
  padding-top: 0;
}
.jump-popup-wrapper .open-date-picker .react-datepicker .react-datepicker__current-month {
  font-size: 1.6rem;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__day {
  padding: 0;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__day--highlighted:after {
  background-color: transparent;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__day--today:before {
  width: 1.7rem;
  height: 1.7rem;
}
.jump-popup-wrapper .open-date-picker .react-datepicker__day:hover:before {
  width: 1.7rem;
  height: 1.7rem;
  background-color: #dabc64;
  border-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Calendar/DayView/JumpToDayPopup.scss","webpack://./src/Styles/Material.scss","webpack://./src/Styles/Base.scss","webpack://./src/Styles/Variables.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gBAAA;EACA,eAAA;ADKF;;ADuBA;EACE,cArCU;ACiBZ;;AEhBA;EACE,gBCoBkB;EDnBlB,yBAAA;EACA,WHsCa;ACnBf;;AEhBA;EAEE,WHkCgB;EGjChB,iBAAA;EACA,sBAAA;AFkBF;;AEfA;EAEE,iBAAA;AFiBF;;AEdA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,qBAAA;EACA,SAAA;AFiBF;;AA3CA;EACE,qBAAA;EACA,kBAAA;AA8CF;AA5CE;EAJF;IAKI,aAAA;EA+CF;AACF;AA7CE;EACE,cDRU;ECSV,mBAAA;EACA,eAAA;EACA,iBAAA;AA+CJ;AA5CE;EACE,kBAAA;EACA,aGkBgB;EHjBhB,2BAAA;EACA,mBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EAIA,2DAAA;EAEA,cDlCY;AC6EhB;AAzCI;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AA2CN;AAxCI;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;AA0CN;AAxCM;EACE,YAAA;AA0CR;AAtCI;EACE,iBAAA;AAwCN;AAtCM;EACE,eAAA;AAwCR;AApCI;;EAEE,gBAAA;EACA,4CAAA;AAsCN;AAlCE;EACE,SAAA;AAoCJ;AAnCI;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AAqCN;AApCM;EACE,4BAAA;EACA,mBAAA;AAsCR;AAlCI;EACE,cDpFM;ECqFN,UAAA;EACA,SAAA;EACA,qBAAA;EACA,+CAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;AAoCN;AAnCM;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cD5FM;EC6FN,cAAA;AAqCR;AAjCI;EACE,cDtGM;ECuGN,qBAAA;EACA,+CAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;AAmCN;AAlCM;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cD9GM;EC+GN,cAAA;AAoCR;AAhCI;EACE,WAAA;AAkCN;AAjCM;EACE,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,cAAA;AAmCR;AA/BI;EAEE,iBAAA;AAgCN;AA7BI;EACE,UAAA;AA+BN;AA5BI;EACE,6BAAA;AA8BN;AA3BI;EACE,aAAA;EACA,cAAA;AA6BN;AA1BI;EACE,aAAA;EACA,cAAA;EACA,yBDtIC;ECuID,gBAAA;AA4BN","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n@import '~/Styles/Material';\n@import '~/Styles/Base';\n\n.jump-popup-wrapper {\n  display: inline-block;\n  position: relative;\n\n  @media (max-width: $tablet) {\n    display: none;\n  }\n\n  .open-jump-popup {\n    color: $borderColor;\n    margin-left: 0.5rem;\n    cursor: pointer;\n    font-size: 1.5rem;\n  }\n\n  .jump-popup {\n    position: absolute;\n    z-index: $modalConfirmLayer;\n    transform: translateX(-50%);\n    margin-left: 1.6rem;\n    margin-top: 0.1rem;\n\n    background: white;\n    padding: 1rem 1rem 0;\n    display: flex;\n    flex-flow: column;\n    align-items: stretch;\n\n    -webkit-box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);\n    -moz-box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);\n    box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);\n\n    color: $darkTextColor;\n\n    &__heading {\n      margin: 0 0 1rem;\n      font-size: 2rem;\n      width: 100%;\n    }\n\n    &__body {\n      display: flex;\n      flex-flow: column;\n      align-items: flex-start;\n      align-content: center;\n      margin: 0 0 0rem;\n      width: 18rem;\n\n      .open-date-picker {\n        margin: auto;\n      }\n    }\n\n    &__buttons {\n      text-align: right;\n\n      .btn-default {\n        min-width: 8rem;\n      }\n    }\n\n    label,\n    .label {\n      font-weight: 100;\n      -webkit-font-smoothing: subpixel-antialiased;\n    }\n  }\n\n  .open-date-picker .react-datepicker {\n    border: 0;\n    &__current-month {\n      word-spacing: 4rem;\n      margin-bottom: 1rem;\n      font-weight: normal;\n      &:first-line {\n        font-size: 1.8rem !important;\n        font-weight: normal;\n      }\n    }\n\n    &__navigation--previous {\n      color: $textColor;\n      left: 1rem;\n      top: 3rem;\n      display: inline-block;\n      font: normal normal normal 1.4rem/1 FontAwesome;\n      font-size: inherit;\n      text-rendering: auto;\n      overflow: visible;\n      &:after {\n        content: '\\F053';\n        font-size: 1.2rem;\n        font-weight: normal;\n        color: $borderColor;\n        text-indent: 0;\n      }\n    }\n\n    &__navigation--next {\n      color: $textColor;\n      display: inline-block;\n      font: normal normal normal 1.4rem/1 FontAwesome;\n      font-size: inherit;\n      text-rendering: auto;\n      right: 1.2rem;\n      top: 3rem;\n      overflow: visible;\n      &:after {\n        content: '\\F054';\n        font-size: 1.2rem;\n        font-weight: normal;\n        color: $borderColor;\n        text-indent: 0;\n      }\n    }\n\n    &__month-container {\n      width: 100%;\n      .react-datepicker__header {\n        text-align: center;\n        margin: auto;\n        font-family: Raleway !important;\n        padding-top: 0;\n      }\n    }\n\n    .react-datepicker__current-month {\n      @extend .day-heading;\n      font-size: 1.6rem;\n    }\n\n    &__day {\n      padding: 0;\n    }\n\n    &__day--highlighted:after {\n      background-color: transparent;\n    }\n\n    &__day--today:before {\n      width: 1.7rem;\n      height: 1.7rem;\n    }\n\n    &__day:hover:before {\n      width: 1.7rem;\n      height: 1.7rem;\n      background-color: $gold;\n      border-radius: 0;\n    }\n  }\n}\n",".layered {\n  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.layered-no-overlap {\n  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.no-gutter > [class*='col-'] {\n  padding-right: 0;\n  padding-left: 0;\n}\n","@import 'Colors.scss';\n@import 'Variables.scss';\n\n.heading {\n  font-weight: $headingFontWeight;\n  text-transform: uppercase;\n  color: $headingColor;\n}\n\n.day-heading {\n  @extend .heading;\n  color: $dayHeadingColor;\n  font-size: 1.2rem;\n  padding-bottom: 0.5rem;\n}\n\n.current-day-heading {\n  @extend .day-heading;\n  font-weight: bold;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  -webkit-clip-path: inset(50%);\n  clip-path: inset(50%);\n  border: 0;\n}\n","$desktop: 1441px;\n$hdlaptop: 1281px;\n$laptop: 1024px;\n$tablet: 768px;\n$mobile: 600px;\n$smobile: 425px;\n\n// Body\n$body-bg: #f5f8fa;\n\n// Borders\n$laravel-border-color: darken($body-bg, 10%);\n$list-group-border: $laravel-border-color;\n$navbar-default-border: $laravel-border-color;\n$panel-default-border: $laravel-border-color;\n$panel-inner-border: $laravel-border-color;\n\n//background\n$background-color: #fff;\n\n$page-min-height: 56rem;\n\n$eventTextSize: 1.1rem;\n\n$headingFontWeight: 200;\n\n// Z-index layers\n$debugLayer: 10000;\n$eventLayer: 100;\n$colorPickerLayer: 200;\n$navLayer: 4000;\n$overEventLayer: 5000;\n$expandedEventLayer: 3500;\n$stickerLayer: 3000;\n$modalOverlayLayer: 5000;\n$modalBaseLayer: 6000;\n$modalConfirmationLayer: 10000;\n$checklistLayer: 500;\n$taskLayer: 500;\n\n$modalConfirmLayer: 6000;\n$modalContentLayer: 10000;\n\n$baseStickerSize: calc((100vw - 34rem - (50vw - 16rem) * 0.25) * 0.05);\n$tabletStickerSize: calc((100vw - 18rem - (50vw - 7rem) * 0.25) * 0.05);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
